export const rootUrl = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : "");
// export const rootUrl = `http://${window.location.hostname}:8016`;
// export const rootUrl = "https://jaza-soft.com";
export const oauthUrl = `${rootUrl}/oauth/token`;
export const appUrl = `${rootUrl}/api`;

/**
 * @deprecated
 */
export const httpUrl = `${rootUrl}/api`;
